import React from 'react';
import { TOOLTIP_POSITION } from 'react-covideo-common/dist/components/Tooltip/types';
import styled, { css, CSSProperties, useTheme } from 'styled-components/macro';
import { FormikLabelInfo } from './FormikInfoTooltip';

const CommonStyles = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  display: flex;
  gap: 2px;
`;

const StyledLabel = styled.label<{ disabled?: boolean }>`
  ${CommonStyles}
  color: ${({ theme }) => theme.colors.neutral[60]};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const StyledParagraph = styled.p<{ disabled?: boolean }>`
  ${CommonStyles}
  color: ${({ theme }) => theme.colors.neutral[60]};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

interface IFormikLabelProps {
  name?: string;
  label: string | React.ReactNode;
  isRequired?: boolean;
  disabled?: boolean;
  info?: string | React.ReactNode;
  labelStyles?: CSSProperties | undefined;
  asteriskStyles?: CSSProperties;
  tooltipPosition?: TOOLTIP_POSITION | undefined;
}

export const FormikLabel: React.FC<IFormikLabelProps> = ({
  name,
  label,
  isRequired,
  disabled,
  info,
  labelStyles,
  asteriskStyles,
  tooltipPosition,
}) => {
  const themes = useTheme();
  if (name) {
    return (
      <StyledLabel htmlFor={name} disabled={disabled} style={labelStyles}>
        {label}{' '}
        {isRequired && (
          <span
            style={{ color: themes.colors.primary[100], ...asteriskStyles }}
          >
            *
          </span>
        )}{' '}
        {info && (
          <FormikLabelInfo info={info} tooltipPosition={tooltipPosition} />
        )}
      </StyledLabel>
    );
  }
  return (
    <StyledParagraph disabled={disabled} style={labelStyles}>
      {label}{' '}
      {isRequired && (
        <span style={{ color: themes.colors.primary[100], ...asteriskStyles }}>
          *
        </span>
      )}{' '}
      {info && (
        <FormikLabelInfo info={info} tooltipPosition={tooltipPosition} />
      )}
    </StyledParagraph>
  );
};
